import React from 'react'
import { Box } from '@mui/material'
import DialogAdd from './Add'
import Liste from './Liste'
import SearchBar from './SearchBar'
import Title from '../SpiderWebSite/components/Title'

export default function Partenaire() {
    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                {/*---------------- debut titre --------------*/}
                <Title
                    intitule='Partenaire'
                />
                {/*---------------- fin titre --------------*/}


                {/*---------------- debut add --------------*/}

                <Box sx={{ width: "50%" }}>
                    <SearchBar />
                </Box>

                {/*---------------- fin add --------------*/}


                {/*---------------debut SearchBar --------- */}

                <Box>
                    <DialogAdd />
                </Box>

                {/* ------------------fin  SearchBar ------------*/}
            </Box>

            {/*---------------- debut Liste -----------------*/}
            <Liste />
            {/*--------------- fin Liste ------------------ */}
        </Box>
    )
}
